export default __webpack_public_path__ + "static/media/head04_zh_cn_pc@2x.90697ee5.png";